var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3999 17.9482V20.8613M13.7718 18.9977L16.82 20.6866M36.9937 18.7432L33.9325 20.4393M25.3927 10.9922V14.9626M17.8826 13.9356L19.1148 15.5888M32.8726 13.6779L31.6404 15.3311M40.2442 24.6221C40.2442 32.6976 33.6976 39.2442 25.6221 39.2442C17.5465 39.2442 11 32.6976 11 24.6221C11 16.5465 17.5465 10 25.6221 10C33.6976 10 40.2442 16.5465 40.2442 24.6221ZM29.3631 24.8893C29.3631 27.0821 27.5855 28.8597 25.3928 28.8597C23.2 28.8597 21.4224 27.0821 21.4224 24.8893C21.4224 22.6965 23.2 20.9189 25.3928 20.9189C27.5855 20.9189 29.3631 22.6965 29.3631 24.8893Z",
    stroke: "#4D5052",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarMeter);
export default __webpack_public_path__ + "static/media/car-meter.499a47d1b1db5b409f79f474cb3a63fb.svg";
export { ForwardRef as ReactComponent };